import React, { useMemo } from "react";
import TableWidget from "../../../../components/tables/TableWidget";
import ClientAwbHistoryActionButtons from "./components/ActionButtons/ClientAwbHistoryActionButtons";
import { useAppDispatch, useAppSelector } from "../../../../redux/hooks";
import useRoutesHelper from "../../../../hooks/useRoutesHelper";
import {
  awbHistoryTableHeader,
  getAwbTableData,
} from "./components/tableConfigs/awbHistoryTableConfig";
import { TableActions } from "../../../../components/tables/tableContext/TableContext";
import { fetchAwbHistory } from "../../../../redux/api/expedition.api";

function AwbTable() {
  const dispatch = useAppDispatch();
  const { routeMainParam } = useRoutesHelper();

  const { clientId } = routeMainParam as { clientId: string };

  const {
    expedition: {
      awbHistory: {
        data: { data: dataAwb, total: totalAwb },
        isLoading: isLoadingAwb,
      },
      workingRoutesNodes: {
        data: { data: clientsNodesData },
        isLoading: isLoadingNodes,
      },
      awbStatuses: { data: awbStatusesData, isLoading: isLoadingAwbStatus },
    },
  } = useAppSelector((state) => ({
    expedition: state.expedition,
  }));

  const handleAwbTableActions = (action: TableActions) => {
    if (
      clientId &&
      action.tablePagination.page &&
      action.tablePagination.rowsPerPage &&
      action.tableSearch
    ) {
      dispatch(
        fetchAwbHistory({
          id_client: clientId,
          page: action.tablePagination.page,
          perPage: action.tablePagination.rowsPerPage,
          pctlivrare: action.tableSearch.pctlivrare,
          nodDestinatie: action.tableSearch.nodDestinatie,
          status: action.tableSearch.status,
          doc_trans: action.tableSearch.doc_trans,
        }),
      );
    }
  };

  const awbHistoryTableHeaderNew = useMemo(
    () =>
      awbHistoryTableHeader.map((item) => {
        if (!isLoadingNodes && item.value === "nodDestinatie") {
          const nodesDropdown = clientsNodesData?.map(
            ({ nodNume, id_nod }) => ({
              label: nodNume,
              value: id_nod,
            }),
          );
          return {
            withFilter: [{ label: "Toate", value: 0 }, ...nodesDropdown],
            ...item,
          };
        }
        if (!isLoadingAwbStatus && item.value === "status") {
          const awbStatusesDropdown = awbStatusesData?.map(
            ({ denumire, valoare }) => ({
              label: denumire,
              value: valoare,
            }),
          );
          return {
            withFilter: [
              { label: "Toate", value: "all" },
              ...awbStatusesDropdown,
            ],
            ...item,
          };
        }
        return item;
      }),
    [awbStatusesData, clientsNodesData, isLoadingAwbStatus, isLoadingNodes],
  );

  return (
    <TableWidget
      tableHeaderData={awbHistoryTableHeaderNew}
      tableItemsData={getAwbTableData(dataAwb)}
      totalItems={totalAwb}
      tableLoading={isLoadingAwb}
      handleTableActions={handleAwbTableActions}
      ActionButtonsComponent={(props: any) => (
        <ClientAwbHistoryActionButtons {...props} />
      )}
      borderedRow
    />
  );
}

export default AwbTable;
